import {
  Directive,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appScrollNearEnd]',
})
export class CustomInfiniteScrollDirective implements OnInit {
  @Output() nearEnd: EventEmitter<void> = new EventEmitter<void>();

  /**
   * threshold in PX when to emit before page end scroll
   */
  @Input() threshold = 10;

  private window!: Window;

  constructor(private readonly el: ElementRef) {}

  ngOnInit(): void {
    // save window object for type safety
    this.window = window;
  }
  // Listen to the 'scroll' event on the host element
  @HostListener('scroll', ['$event.target'])
  onScroll(event: EventTarget | null) {
    const scrollTop = this.el.nativeElement.scrollTop;
    const scrollHeight = this.el.nativeElement.scrollHeight;
    const clientHeight = this.el.nativeElement.clientHeight;

    if (scrollTop + clientHeight >= scrollHeight - this.threshold) {
      this.nearEnd.emit();
    }
  }
}
